<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WlMCHU/tc-custom/9781446358184.jpg?1726519260675" alt="This image is the cover for the book Spells and How They Work, The Paranormal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spells and How They Work, The Paranormal
      </h1>
      <p class="bookDescription body article font2">
        <b>The ethical way to perform healing spells, love spells, weather spells, sex magic, and more—from the authors of <i>A Witches’ Bible</i>.</b><br/>  <br/> This book covers all aspects of spell-making—including psychic self-defense, sex magic, cabalistic magic, and talismans. There is a generous collection of actual spells, past and present, drawn from history, literature, folklore, old grimoires, and the years of experience of the authors, respected Wiccans and leaders in the pagan world.<br/>  <br/><i>Spells and How They Work</i> is part of The Paranormal, a series that resurrects rare titles, classic publications, and out-of-print texts, as well as publishes new supernatural and otherworldly ebooks for the digital age. The series includes a range of paranormal subjects from angels, fairies, and UFOs to near-death experiences, vampires, ghosts, and witchcraft.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Farrar, Stewart Farrar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      F+W Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1dda119c